var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewRec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1659 0L18.8645 0L27.932 9.45128V27.8341C27.932 30.1369 26.0689 32 23.7741 32H8.1659C5.86306 32 4 30.1369 4 27.8341L4 4.1659C3.99996 1.86306 5.86302 0 8.1659 0V0Z",
    fill: "#0ABAB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8574 0V9.37931H27.9329L18.8574 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63086 23.876V18.0309H11.1176C11.7333 18.0309 12.2211 18.1989 12.5889 18.5427C12.9567 18.8785 13.1406 19.3343 13.1406 19.902C13.1406 20.4697 12.9567 20.9255 12.5889 21.2613C12.2211 21.6052 11.7333 21.7731 11.1176 21.7731H10.1261V23.876H8.63086ZM10.1261 20.5017H10.9497C11.1736 20.5017 11.3495 20.4537 11.4695 20.3418C11.5894 20.2379 11.6534 20.0939 11.6534 19.9021C11.6534 19.7102 11.5894 19.5662 11.4695 19.4623C11.3495 19.3503 11.1736 19.3024 10.9497 19.3024H10.1261V20.5017ZM13.7563 23.876V18.0309H15.8273C16.2351 18.0309 16.6189 18.0869 16.9787 18.2069C17.3385 18.3268 17.6663 18.4947 17.9542 18.7266C18.2421 18.9505 18.4739 19.2543 18.6418 19.6382C18.8017 20.022 18.8897 20.4618 18.8897 20.9575C18.8897 21.4453 18.8018 21.885 18.6418 22.2688C18.4739 22.6526 18.2421 22.9565 17.9542 23.1804C17.6663 23.4122 17.3385 23.5801 16.9787 23.7001C16.6189 23.82 16.2351 23.876 15.8273 23.876H13.7563ZM15.2196 22.6047H15.6513C15.8832 22.6047 16.0991 22.5807 16.299 22.5247C16.4909 22.4688 16.6748 22.3808 16.8507 22.2609C17.0187 22.1409 17.1546 21.973 17.2505 21.7491C17.3465 21.5252 17.3945 21.2613 17.3945 20.9575C17.3945 20.6456 17.3465 20.3818 17.2505 20.1579C17.1546 19.934 17.0187 19.7661 16.8507 19.6462C16.6748 19.5262 16.4909 19.4383 16.299 19.3823C16.0991 19.3263 15.8832 19.3023 15.6513 19.3023H15.2196V22.6047ZM19.6414 23.876V18.0309H23.7993V19.3023H21.1366V20.2378H23.2635V21.5012H21.1366V23.876H19.6414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRec);
export default __webpack_public_path__ + "static/media/new-rec.df7a2ebba171c579fa54fc3a4d5c415b.svg";
export { ForwardRef as ReactComponent };